import s from "./td-longtail-vue-components156.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var a = function() {
  var r = this, e = r._self._c, t = r._self._setupProxy;
  return r.offerColorVariants ? e("div", { staticClass: "product-offer-color-select" }, [e("span", { staticClass: "product-offer-color-select__label" }, [r._v("Farben")]), e(t.ColorSelector, { staticClass: "product-offer-color-select__list", attrs: { variants: r.offerColorVariants, value: r.value, circle: "", "no-title": r.noTitle }, on: { input: (o) => r.$emit("input", o) } })], 1) : r._e();
}, c = [], n = /* @__PURE__ */ l(
  s,
  a,
  c,
  !1,
  null,
  "823853df"
);
const u = n.exports;
export {
  u as default
};
